export default __webpack_public_path__ + "static/media/Combined-logos.03f86ec5.png";